import { useMediaQuery } from './useMediaQuery';

// Detect actual mobile devices once at module load (stable, no re-renders).
// Touch-only + coarse pointer = real phone/tablet, not a desktop with a narrow viewport
// from a browser extension side panel.
const IS_REAL_MOBILE =
  typeof window !== 'undefined' &&
  window.matchMedia('(pointer: coarse)').matches &&
  window.screen?.width <= 1024;

export const useIsMobile = (): boolean => {
  const viewportNarrow = useMediaQuery('(max-width: 767px)');
  // Real mobile device: always mobile regardless of orientation.
  // Non-mobile device with narrow viewport: treat as mobile.
  return IS_REAL_MOBILE || viewportNarrow;
};
